import { generateHash } from "./hashUtil";
import api from "./axiosInstance";

const processedSessionData = async (
  sessionID,
  type,
  hexHash,
  token,
  setAnalysisSessionData
) => {
  //   const stringParams = {
  //     sessionId: sessionID ? sessionID.toString() : "",
  //     type: currentPath === "/socialMediaCrawler" ? "section" : "sentiment",
  //   };
  //   const hexHash = generateHash(stringParams);

  try {
    const { data } = await api.get(`/api/processedData`, {
      params: {
        sessionId: sessionID,
        type: type,
        HPPcode: hexHash,
      },
      headers: {
        // Security Headers
        "X-XSS-Protection": "1; mode=block",
        Authorization: `Bearer ${token}`,
        "X-Content-Type-Options": "nosniff",
        "X-Frame-Options": "DENY",
        "Referrer-Policy": "strict-origin-when-cross-origin",
        "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

        // Standard Headers
        "Content-Type": "application/json",
      },
    });

    setAnalysisSessionData(data);
    // setServerResponse(data);
    return data;
  } catch (err) {
    console.error(err);
  }
};

export default processedSessionData;
//
